import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { PcpAuthModule } from "../pcp-auth.module";
import * as fromAuth from "../store/auth.selectors";


@Injectable({
    providedIn: PcpAuthModule,
})
export class EnetTokenProvider {

    readonly enetToken$ = this.store.select(fromAuth.selectEnetToken);

    constructor(private readonly store: Store) {
    }
}
